export default __webpack_public_path__ + "static/media/Chevron_Right.ee81be47.svg";